export function getStudentDisplayName(student, fallback) {
  return (
    [student?.firstname, student?.lastname].filter(Boolean).join(" ") ||
    student?.name ||
    fallback
  );
}
